import { paddingLarge, paddingSmall } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import { CommentAttachmentType } from "../types";

const CommentAttachmentName = ({ attachment }: { attachment: CommentAttachmentType.Name }) => {
	return (
		<Text
			testID="CommentAttachmentName"
			color="TextLight"
			xs
			style={{
				paddingHorizontal: paddingLarge,
				paddingBottom: paddingSmall,
			}}
		>
			{attachment.name}
		</Text>
	);
};
export default CommentAttachmentName;
